<template>
    <ul v-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <router-link :to="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </router-link>
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div v-if="isMobile" :class="className + '__link gnb__link--toggle'">
                    <h2>{{ item.title }}</h2>
                </div>
                <router-link v-else :to="item.path" :class="className + '__link gnb__link--toggle'">
                    <h2>{{ item.title }}</h2>
                </router-link>
                <ul :class="className + '__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{ child.title }}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
    },
    data: function () {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "Auctions",
                    path: "/auction-halls/A",
                    children: [
                        {
                            title: "Auction",
                            path: "/auction-halls/A",
                        },
                        {
                            title: "Special Sale Online",
                            path: "/auction-halls/B",
                        },
                        // {
                        //     title: "(구)Live Auction",
                        //     path: "/auction-halls/C",
                        // },
                        {
                            title: "지난경매",
                            path: "/auction-results",
                        },
                    ],
                },
                {
                    title: "Private Sales",
                    path: "/private-sales/LIST",
                },
                {
                    title: "Permanent Sales",
                    path: "/permanent-sales",
                },
                // {
                //     title: "Artists",
                //     path: "/artists",
                // },
                {
                    title: "How to bid",
                    path: "/how-to/JOIN",
                    children: [
                        {
                            title: "응찰안내",
                            path: "/how-to/JOIN",
                        },
                        {
                            title: "위탁안내",
                            path: "/how-to/consignment",
                        },
                        {
                            title: "FAQ",
                            path: "/center/faqs",
                        },
                    ],
                },
                {
                    title: "Services",
                    path: "/collection",
                    children: [
                        {
                            title: "소장품 관리",
                            path: "/collection",
                        },
                        {
                            title: "해외미술품 구매대행",
                            path: "/museum-services",
                        },
                        {
                            title: "작품가치 제고",
                            path: "/valuations",
                        },
                    ],
                },
                {
                    title: "About",
                    path: "/about-mission",
                    children: [
                        {
                            title: "About & Mission",
                            path: "/about-mission",
                        },
                        {
                            title: "문의하기",
                            path: "/inquiry",
                        },
                        {
                            title: "공지사항",
                            path: "/center/notice",
                        },
                        {
                            title: "언론보도",
                            path: "/board/press",
                        },
                        {
                            title: "위치안내",
                            path: "/location",
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        isDesktop: function () {
            return this.window.width >= 1200;
        },
        isMobile: function () {
            return this.window.width < 1200;
        },
    },
    created: function () {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function () {},
    methods: {
        handleResize: function () {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>